import { TimezoneType } from 'shared/mui/DatePicker/constants/timezones';
import {
  DateRangeTimezoneValue,
  DateRangeValue,
} from 'shared/mui/DatePicker/DateTimeRangeTimezonePicker/DateTimeRangeTimezonePicker';
import { formatInputToTimestamp } from 'utils/date/formatInputToTimestamp';

const RECONCILIATION_STATUS = 'success';

export type ReconciliationFormValues = {
  period: DateRangeValue;
  timezone: DateRangeTimezoneValue;
  merchant: number | null;
  provider: number | null;
  direction: string | null;
  providerFile: File | null;
  merchantFile: File | null;
  providerFileTimezone: TimezoneType | null;
  merchantFileTimezone: TimezoneType | null;
};

export const mapReconciliationFormToFormData = (values: ReconciliationFormValues): FormData => {
  const formData = new FormData();

  formData.append('merchantId', String(values.merchant));
  formData.append('providerId', String(values.provider));
  formData.append('direction', String(values.direction));
  formData.append(
    'dateFrom',
    String(formatInputToTimestamp(values.period[0], { unit: 'seconds' })),
  );
  formData.append('dateTo', String(formatInputToTimestamp(values.period[1], { unit: 'seconds' })));
  formData.append('statuses[]', RECONCILIATION_STATUS);
  formData.append('paymentSystemFile', values.providerFile as File);
  formData.append('paymentMerchantFile', values.merchantFile as File);

  if (values.providerFileTimezone) {
    formData.append('paymentSystemTimezone', values.providerFileTimezone.name);
  }

  if (values.merchantFileTimezone) {
    formData.append('paymentMerchantTimezone', values.merchantFileTimezone.name);
  }

  return formData;
};
